import { FileClient, PageableResponse, RestClient } from "clients/rest";

export type B010070FindRequest = {
  ediKbn: string;
  juchustatusKbn: string;
} & Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  shainCd: string;
  assistantCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B010070FindResponse = {
  juchuworkdenpyoNo: string;
  juchuYmd: string;
  tokuiNm: string;
  meisaisu: string;
  setshohin: string;
  juchuKin: string;
  juchuHaneiKbn: string;
  ediMemo: string;
};

export const B010070Find = (props: B010070FindRequest) => {
  return RestClient.get<PageableResponse<B010070FindResponse[]>>(
    "b010070/find",
    {
      params: props,
    }
  );
};

export type B010070DeleteField = {
  juchuworkdenphpyoNo: string | undefined;
  version: string | undefined;
};

export type B010070DeleteRequest = {
  b010070DeleteFieldList: B010070DeleteField[];
};

//反映処理
export const B010070Delete = (props: B010070DeleteRequest) => {
  return RestClient.delete("b010070/delete", { data: props });
};

export type B010070GetExcelRequest = {
  juchuworkdenpyoNo: string | undefined;
};

// Excel出力処理
export const B010070GetExcel = (props: B010070GetExcelRequest) => {
  return FileClient.get("b010070/get/excel", {
    params: props,
  });
};

export type B010070GetRequest = {
  juchuworkdenpyoNo: string | undefined;
};

export type B010070GetResponse = {
  juchuKbn: string;
  juchuworkdenpyoNo: string;
  juchuYmd: string;
  nohinyoteiYmd: string;
  tokuiShokuchiKbn: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tankaKakeritsu: string;
  zeimarumeKbn: string;
  kinmarumeKbn: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuShokuchiKbn: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  ediMemo: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  seisakuYmd: string;
  shukayoteiYmd: string;
  jisanYmd: string;
  denpyoYmd: string;
  shimeD: string;
  chohaKbn: string;
  hasosakiCd: string;
  hasosakiNm: string;
  hasokbnCd: string;
  hasokbnNm: string;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  ppgakeKbn: string;
  netsukeKbn: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  nohinsaki: string;
  lineCd: string;
  lineNm: string;
  uribaNm: string;
  naisen: string;
  zeiRitsu: string;
  jodaihyojiKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  ediJuchuNo: string;
  ediJuchuKbn: string;
  version: string;
  b010070GetMeiResponse: B010070GetJuchuMei[];
};

type B010070GetJuchuMei = {
  juchugyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  kanosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchutanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbn: string;
  setshohinKbn: string;
  edishohinNm: string;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  sokoshubetsuKbn: string;
  b010070GetMeiKoseiResponse: B010070GetJuchuMeiKosei[];
};

type B010070GetJuchuMeiKosei = {
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  koseisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchutanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  sokoshubetsuKbn: string;
  crtDate: string;
  crtshainCd: string;
};

// 受注ワークデータ取得メソッド
export const B010070Get = (props: B010070GetRequest) => {
  return RestClient.get("b010070/get", {
    params: props,
  });
};

export type B010070CreateRequest = {
  b010070CreateFieldList: B010070CreateField[];
};

export type B010070CreateField = {
  juchuworkdenphpyoNo: string | undefined;
  version: string | undefined;
};

export type B010070CreateResponse = {
  zaikofusokuGyoNoList: number[];
};

//反映処理
export const B010070Create = (props: B010070CreateRequest) => {
  return RestClient.post<B010070CreateResponse>("b010070/create", props);
};
